import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import OperatorDashboardToggle from "./OperatorDashboardStatus";
import OperatorDataGrid from "./OperatorDataGrid";
import OperatorDashboardDemand from "./OperatorDashboardDemand";
import EChartsOperatorGraph from "./EChartsOperatorGraph";
import EChartsGeyserGraph from "./EChartsGeyserGraph";
import ResetGeysers from "./ResetGeysers";
import { useState } from "react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

const styles = {
  container: {
    margin: "0 auto",
    padding: "0 32px",
    maxWidth: "1440px",
  },
};

export default function OperatorDashboardPage() {
  const navigate = useNavigate();
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const request = {
    queryParams: {
      startDate: null,
      endDate: null,
      userTimezone: userTimezone,
    },
  };

  return (
    <div>
      <Grid style={styles.container}>

        {/* Page header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "12px",
            pt: "28px",
            mb: "24px",
            flexWrap: "wrap",
          }}
        >
          {/* Title */}
          <Box>
            <Typography
              sx={{ fontSize: "1.7rem", fontWeight: 700, color: "#fff", letterSpacing: "-0.025em", lineHeight: 1.2 }}
            >
              Tjommie Operator App
            </Typography>
            <Typography sx={{ fontSize: "0.88rem", color: "rgba(255,255,255,0.45)", mt: "4px" }}>
              DSM operator dashboard · live SmartNode status, demand response &amp; control
            </Typography>
          </Box>

          {/* Right-side controls */}
          <Box sx={{ display: "flex", alignItems: "center", gap: "8px", flexShrink: 0 }}>
            {/* Historical view */}
            <Button
              variant="outlined"
              startIcon={<ShowChartIcon sx={{ fontSize: "0.9rem" }} />}
              onClick={() => navigate("/operator/historical-graph/")}
              sx={{
                color: "rgba(255,255,255,0.7)",
                borderColor: "rgba(255,255,255,0.2)",
                fontSize: "0.82rem",
                fontWeight: 500,
                textTransform: "none",
                borderRadius: "8px",
                "&:hover": { borderColor: "rgba(255,255,255,0.5)", bgcolor: "rgba(255,255,255,0.04)" },
              }}
            >
              Historical view
            </Button>

            {/* Reset Geysers */}
            <ResetGeysers />

            {/* Live pill */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                fontSize: "0.75rem",
                color: "rgba(255,255,255,0.65)",
                fontWeight: 500,
                padding: "6px 10px",
                background: "rgba(34,197,94,0.12)",
                border: "1px solid rgba(34,197,94,0.22)",
                borderRadius: "999px",
                whiteSpace: "nowrap",
              }}
            >
              <Box
                sx={{
                  width: "6px",
                  height: "6px",
                  background: "#22C55E",
                  borderRadius: "50%",
                  flexShrink: 0,
                  "@keyframes livePulse": {
                    "0%, 100%": { opacity: 1 },
                    "50%": { opacity: 0.35 },
                  },
                  animation: "livePulse 2s infinite",
                }}
              />
              Live · polling every 60 s
            </Box>
          </Box>
        </Box>

        {/* KPI strip */}
        <Grid container alignItems="center" justifyContent="left">
          <OperatorDashboardToggle />
        </Grid>

        {/* Demand cards */}
        <Grid sx={{ marginTop: "20px" }} container alignItems="center" justifyContent="left">
          <OperatorDashboardDemand />
        </Grid>

        {/* Demand graph */}
        <Grid sx={{ marginTop: "20px" }} container alignItems="center" justifyContent="left">
          {/* Polls like the rest of the dashboard: the data never refreshed, only the target
              and forecast markers did (NEU-1138). No dates = the 24 hours ending now. */}
          <EChartsOperatorGraph request={request} pollingInterval={60000} />
        </Grid>

        {/* Geyser graph */}
        <Grid sx={{ marginTop: "20px" }} container alignItems="center" justifyContent="center">
          <EChartsGeyserGraph request={request} pollingInterval={60000} />
        </Grid>

        {/* Devices data grid */}
        <Grid sx={{ marginTop: "20px" }} container spacing={2} alignItems="center" justifyContent="right">
          <OperatorDataGrid />
        </Grid>

      </Grid>
    </div>
  );
}
